import { resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue";
const _hoisted_1 = {
  class: "composite-colorful-bar-wrapper"
};
const _hoisted_2 = {
  key: 0,
  class: "composite-colorful-bar"
};
const _hoisted_3 = {
  class: "currencies"
};
const _hoisted_4 = {
  class: "layers-wrapper"
};
const _hoisted_5 = {
  class: "percentage-breakdown"
};
const _hoisted_6 = {
  class: "header"
};
const _hoisted_7 = {
  class: "date title"
};
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "Spend", -1);
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "Spons. Sales", -1);
const _hoisted_10 = {
  class: "details"
};
const _hoisted_11 = {
  class: "split-name"
};
const _hoisted_12 = {
  class: "detail-row"
};
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", {
  class: "total split-name"
}, "Total", -1);
const _hoisted_14 = {
  class: "total"
};
const _hoisted_15 = {
  class: "total"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_percentage_value = _resolveComponent("percentage-value");
  const _component_variable_styled_bar = _resolveComponent("variable-styled-bar");
  const _component_layer_bars = _resolveComponent("layer-bars");
  const _component_dotted_value = _resolveComponent("dotted-value");
  const _component_currency_value = _resolveComponent("currency-value");
  const _component_flex_row = _resolveComponent("flex-row");
  const _component_dropdown_body = _resolveComponent("dropdown-body");
  const _component_b_dropdown = _resolveComponent("b-dropdown");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_b_dropdown, {
    "no-caret": "",
    toggleClass: "dropdown-selector",
    ref: "detailDropdown",
    strategy: "fixed"
  }, {
    "button-content": _withCtx(() => [$options.validValues ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createElementVNode("section", _hoisted_3, [_withDirectives(_createVNode(_component_percentage_value, {
      ref: "oneCurrency",
      loading: $props.loading,
      class: "little-percentage",
      value: $props.values[$props.activeType][0],
      color: $props.colors[0]
    }, null, 8, ["loading", "value", "color"]), [[_vShow, $options.showLittleCurrency[0]]]), _withDirectives(_createVNode(_component_percentage_value, {
      ref: "twoCurrency",
      loading: $props.loading,
      class: "little-percentage",
      value: $props.values[$props.activeType][1],
      color: $props.colors[1]
    }, null, 8, ["loading", "value", "color"]), [[_vShow, $options.showLittleCurrency[1]]]), _withDirectives(_createVNode(_component_percentage_value, {
      ref: "threeCurrency",
      loading: $props.loading,
      class: "little-percentage",
      value: $props.values[$props.activeType][2],
      color: $props.colors[2]
    }, null, 8, ["loading", "value", "color"]), [[_vShow, $options.showLittleCurrency[2]]]), _withDirectives(_createVNode(_component_percentage_value, {
      ref: "fourCurrency",
      loading: $props.loading,
      class: "little-percentage",
      value: $props.values[$props.activeType][3],
      color: "#71777F"
    }, null, 8, ["loading", "value"]), [[_vShow, $options.showLittleCurrency[3]]])]), _createElementVNode("div", _hoisted_4, [_createVNode(_component_layer_bars, null, {
      default: _withCtx(() => [_createVNode(_component_variable_styled_bar, {
        ref: "four",
        class: "four",
        value: $props.barValues[3],
        max: $props.max,
        min: $props.min,
        color: $props.colors[3],
        height: 6
      }, null, 8, ["value", "max", "min", "color"]), _createVNode(_component_variable_styled_bar, {
        ref: "three",
        class: "three",
        value: $props.barValues[2],
        max: $props.max,
        min: $props.min,
        color: $props.colors[2],
        height: 6
      }, null, 8, ["value", "max", "min", "color"]), _createVNode(_component_variable_styled_bar, {
        ref: "two",
        class: "two",
        value: $props.barValues[1],
        max: $props.max,
        min: $props.min,
        color: $props.colors[1],
        height: 6
      }, null, 8, ["value", "max", "min", "color"]), _createVNode(_component_variable_styled_bar, {
        ref: "one",
        class: "one",
        value: $props.barValues[0],
        max: $props.max,
        min: $props.min,
        color: $props.colors[0],
        height: 6
      }, null, 8, ["value", "max", "min", "color"])]),
      _: 1
    })])])) : _createCommentVNode("", true)]),
    default: _withCtx(() => [_createVNode(_component_dropdown_body, null, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_5, [_createElementVNode("section", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_renderSlot(_ctx.$slots, "date")]), _hoisted_8, _hoisted_9]), _createElementVNode("section", _hoisted_10, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.types, ({
        short_name,
        color
      }, index) => {
        return _openBlock(), _createElementBlock("div", {
          class: "detail-row",
          key: short_name
        }, [_createVNode(_component_dotted_value, {
          gap: 8,
          value: short_name,
          color: color,
          size: 12,
          styles: {
            padding: '12px 16px'
          },
          align: "left",
          class: "detail dotted"
        }, {
          default: _withCtx(() => [_createElementVNode("span", _hoisted_11, _toDisplayString(short_name), 1)]),
          _: 2
        }, 1032, ["value", "color"]), _createVNode(_component_flex_row, {
          class: "detail",
          gap: 8,
          align: "left"
        }, {
          default: _withCtx(() => [_createVNode(_component_percentage_value, {
            value: $props.values.SPEND[index]
          }, null, 8, ["value"]), _createVNode(_component_currency_value, {
            value: $props.currencies.SPEND[index],
            limit: 1_000,
            precision: 2,
            "zero-initials": ""
          }, null, 8, ["value"])]),
          _: 2
        }, 1024), _createVNode(_component_flex_row, {
          class: "detail",
          gap: 8,
          align: "left"
        }, {
          default: _withCtx(() => [_createVNode(_component_percentage_value, {
            value: $props.values.SPONSORED_SALES[index]
          }, null, 8, ["value"]), _createVNode(_component_currency_value, {
            value: $props.currencies.SPONSORED_SALES[index],
            limit: 1_000,
            precision: 2,
            "zero-initials": ""
          }, null, 8, ["value"])]),
          _: 2
        }, 1024)]);
      }), 128)), _createElementVNode("div", _hoisted_12, [_hoisted_13, _createElementVNode("div", _hoisted_14, [_renderSlot(_ctx.$slots, "spend-total")]), _createElementVNode("div", _hoisted_15, [_renderSlot(_ctx.$slots, "sponsored-total")])])])])]),
      _: 3
    })]),
    _: 3
  }, 512)]);
}